import { CampaignEvent } from "./appt.model";
import { eCampaignItemStatusAction } from "./enum.model";
import { IntDropDownItem, SimpleResponse } from "./genericResponse.model";
import { SearchQueryResponse } from "./search.model";


export interface CampaignItem {
  campaignID: number;
  itemID: number;
  campaignEventID: number;
  objectID: number;
  runID: number;
  status: number;
  dtModified: Date;
  cLPUserID: number;
}

export interface UsersResponse extends SimpleResponse {
  users: IntDropDownItem[];
  isShowUserDD: boolean
}

export interface CampaignItemListResponse extends SimpleResponse {
  CampaignItems: CampaignItem[];
}

export interface CampaignItemExtendedListResponse extends SimpleResponse {
  campaignItemExtendedList: CampaignItemExtended[];
}

export interface CampaignItemExtended extends CampaignItem {
  campaignTemplateName: string;
  userName: string;
  campaignEventName: string;
}

export interface AutomationActions {
  statusAction: eCampaignItemStatusAction;
  campaignIds: number[];
  contactID: number;
  leadID: number;
  clpuserId: number;
  clpCompanyID: number;
}

export interface ActivateSFAResponse extends SimpleResponse {
  campaignItems: CampaignItemExtended[];
}

export interface CampaignLead {
  leadID: number;
  contactId: number;
  fullName: string;
  contactLast: string;
  companyId: number;
  companyName: string;
  companyNameSort: string;
  dtStart: Date;
  dtStartShow: string;
  dtEnd: Date;
  dtEndShow: string;
  leadStatusDisplay: string;
  navURL: string;
  contactURL: string;
  toolTip: string;
  userId: number;
  userName: string;
  userNameSort: string;
  leadDesc: string;
  currentEvent: string;
  statusCode: number;
  statusDisplay: string;
}

export interface CampaignLeadResponse {
  campaignLeadList: CampaignLead[];
}

export interface CampaignContactListResponse {
  campaignContacts: CampaignContact[];
}

export interface CampaignContact {
  contactID: number;
  companyID: number;
  firstName: string;
  lastName: string;
  lastFirst: number;
  lastFirstSort: string;
  imageURL: string;
  navURL: string;
  navURLEdit: string;
  userNameSort: string;
  companyNameShow: string;
  companyName: string;
  emailValue: string;
  emailDisplay: string;
  phoneValue: string;
  currentEvent: string;
  statusCode: string;
  statusDisplay: string;
  uFirstName: string;
  uLastName: string;
  eblastAddress: string;
  email: string;
  email2: string;
  email3: string;
  phone: string;
  mobile: string;
  homePhone: string;
  fax: string;
  companyType: number;
  coCompanyName: string;
  status: number;
  clpUserId: number;
}

export interface AutomationActionsByOwner {
  statusAction: eCampaignItemStatusAction;
  ownerIds: number[];
  ownerType: number;
  campaignId: number;
  clpuserId: number;
  clpCompanyID: number;
}

export interface CampaignOwnerListResponse {
  campaignContacts: CampaignContact[];
  campaignLeadList: CampaignLead[];
}

export interface AddToProcessLoadResponse extends SimpleResponse{
  users: IntDropDownItem[];
  campaignEventList: CampaignEvent[];
}

export interface AddContactToProcessResponse{
  contactsAdded: number;
  contactsNotAdded: number;
  campaignID: number;

}

export interface AddToProcessRequest {
  campaignID: number;
  campaignTemplateID: number;
  clpuserID: number;
  processAll: boolean;
  searchQuery: SearchQueryResponse;
  contactIds: number[];
  ownertype: number;
}
